import * as React from 'react'
import * as styles from './TextLiveStatus.module.scss'
import * as cn from 'classnames'

interface TextLiveStatusProps {
  label: string
  isStandalone?: boolean
}

const TextLiveStatus = ({ label, isStandalone }: TextLiveStatusProps) => (
  <div className={cn(styles.TextLiveStatus, 'tst-live-status',
    { [styles.isStandalone]: isStandalone })}>
    {label}
  </div>
)

export default TextLiveStatus
